<template>
  <div id="app">
    <HeaderMobile v-if="isMobile()" />
    <Header v-else />
    <transition name="fade">
      <router-view />
    </transition>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import HeaderMobile from "@/components/HeaderMobile.vue";
import Footer from "@/components/Footer.vue";
import { mapGetters } from 'vuex';

export default {
  name: "app",
  components: {
    Header,
    HeaderMobile,
    Footer
  },
  computed: mapGetters({
    isAuthenticated: 'isAuthenticated',
    headers: 'getSecuredRequestHeader'
  }),
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 576) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.$store.dispatch("fetchUserDataIfLoggedIn");
  }
};
</script>

<style lang="scss">
.fade {
  &-enter-active,
  &-leave-active {
    transition: all 200ms ease-out;
  }

  &-enter-active {
    transition-delay: 200ms;
  }
  &-leave-active ~ &-enter-active {
    position: absolute;
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }
  &-enter-to,
  &-leave {
    opacity: 1;
    transform: translateX(0);
  }
  &-enter {
    transform: translateX(50px);
  }
  &-leave-to {
    transform: translateX(-50px);
  }
}
</style>
